import React from 'react';
import ReactDOM from 'react-dom/client';
import 'shared/styles/index.css';
import AppWrapper from 'app/App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppWrapper/>
  </React.StrictMode>
);
